import { ChangelogTypeEnum } from '../../enum/changelog-type.enum';
import { SelectableEntity } from '../entity/selectable-entity';

export class ChangelogEntry extends SelectableEntity {
  public date: Date;
  public title: string;
  public message: string;
  public type: ChangelogTypeEnum;

  constructor(
    id: string,
    title: string,
    message: string,
    type: ChangelogTypeEnum
  ) {
    super(id, title, 'label');
    this.id = id ?? null;
    this.title = title;
    this.message = message;
    this.type = type;
  }
}
